<template lang="pug">
div
  table.fold-table(:class="classname")
    thead
      tr(v-if="theadHasChild") 
        th.head_no_padding(v-for="item in columns", :colspan="item.children.length" class="bl center") {{item.title}}
          span(v-if="item.key")
            slot(:name="item.key")
      tr(v-if="columnChildren.length != 0")
        th(ref="thCell", v-for="column,index in columnChildren", :class="tcellCustomClass(column)", :style="column.style")
          span(style="margin-right: 30px;", v-if="checkbox == true && index == 0")
            v-checkbox(v-model="checkAll", @change.native="onCheckAll") 
          span(v-if="checkbox == true && index == 0")
          | {{column.title}}
          span 
            slot(:name="column.key")
          span.sort_icon.margin_icon(v-show="column.sorter")
            i.sort.sort-asc(:class="{'sorted' : checkSorted(column.key, 1)}", @click="orderTable(column, 1)") 
            i.sort.sort-desc(:class="{'sorted' : checkSorted(column.key, 0)}", @click="orderTable(column, 0)") 

    //loading 
    tbody(v-if="isLoading")
      tr
        td.loading(:colspan="columnSpan")
          img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
    //no result
    tbody(v-if="!isLoading && currentPageList.length == 0")
      tr
        td.noresult(:colspan="columnSpan") 无相关数据
    //data list
    tbody(v-if="!isLoading && currentPageList.length != 0 && theadfixed")
      tr
        td.tbody-scroll-td(:colspan="columnSpan")
          .tbody-scroll
            table.data-table
              template(v-for="(item,index) in currentPageList")
                tr
                  td(v-for="(columnItem,columnIndex) in columnChildren", :class="tcellCustomClass(columnItem)", :style="columnItem.style")
                    span
                      slot(:name="columnItem.key + '-td'", :item="item")
                    span(v-if="checkbox == true && columnIndex == 0")
                      v-checkbox(name="columnItem.key" v-model="item.checked" @change.native="checkboxChange(item)") 
                    span(v-html="columnItem.render(index, item[columnItem.key], item)" v-if="columnItem.render")
                    span(v-else-if="!columnItem.render") {{item[columnItem.key]}}
                tr.table-infolist(v-if="item.show")
                  td(:colspan="columnSpan")
                    slot(name="flod-tr", :item="item")


    tbody(v-if="!isLoading && currentPageList.length != 0 && !theadfixed")

      template(v-for="(item,index) in currentPageList")
        //tr(@click="onTRclick(item)")
        tr
          td(v-for="(columnItem,columnIndex) in columnChildren", :class="tcellCustomClass(columnItem)", :style="columnItem.style")
            span
              slot(:name="columnItem.key + '-td'", :item="item")
            span(v-if="checkbox == true && columnIndex == 0")
              v-checkbox(name="columnItem.key" v-model="item.checked" @change.native="checkboxChange(item)") 
            span(v-html="columnItem.render(index, item[columnItem.key], item)" v-if="columnItem.render")
            span(v-else-if="!columnItem.render") {{item[columnItem.key]}}
        tr.table-infolist(v-if="item.show")
          td(:colspan="columnSpan")
            slot(name="flod-tr", :item="item")
  v-pagination(
    v-if="hasPagination",
    :total="total",
    :pn="pg",
    :ps="ps",
    @updatepage="updateAdvicePageData")

</template>

<script>

export default {
  props: {
    classname: {
      type: String,
      default: 'opt-table'
    },
    columns: {
      type: Array,
      require: true
    },
    sortKey: {
      default: ''
    },
    sortOrder: {
      default: 0
    },
    list: {
      default: []
    },
    check_all: false,
    isAllChecked: false,
    checkbox: {
      default: false
    },
    checkbox_length: {
      default: 1
    },
    theadfixed: {
      type: Boolean,
      default: false
    },
    hasPagination: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
        selectAll: false,
        tdWidthList: [],
        tdChildWidthList: [],
        pg: 1,
        ps: 10,
        key: this.sortKey,
        order: this.sortOrder,
        checkAll: this.check_all && this.isAllChecked,
        currentType: 'all',
        currentPageList: []
    }
  },
  watch: {
    isAllChecked(newVal) {
      if(newVal) {
        this.checkAll = true
        this.pushCheckList()
      } else {
        this.checkAll = false
        this.cleanCheckList()
      }
    },
    list() {
      if(!this.hasPagination) {
        this.currentPageList = this.listData
        return
      }
      //初始化pg
      this.pg = 1
      const start = (this.pg - 1) * this.ps
      const end = this.pg * this.ps
      this.currentPageList = this.listData.slice(start, end)
     /* .map((item) => {
        this.$set(item, 'checked', this.selectAll)
        return item
      })
      */
      this.$emit('pageChange', this.currentPageList)
      
    },
    currentPageList: {
      handler() {
        if(this.checkbox) {
          this.checkAll = _.isEmpty(_.find(this.currentPageList, {checked: false})) ? true : false
        }
      },
      deep: true
    },
    sortKey() {
      if(this.key != this.sortKey) {
        this.key = this.sortKey
      }
    },
    sortOrder() {
      if(this.order != this.sortOrder) {
        this.order = this.sortOrder
      }
    }
  },
  computed: {
    total() {
      return this.list.length
    },
    theadHasChild() {
      return this.columns && _.has(this.columns[0], 'children')
    },
    columnSpan() {
      return this.columnChildren.length
    },
    // 获取state中loading的状态
    isLoading() {
      return this.$store.state.tableLoading
    },
    listData() {
      let listData = _.concat([], this.list)
      return listData
    },
    columnChildren() {
      //如果columns中单项有children
      if(this.theadHasChild){
        let children = _.reduce(this.columns, (result, item) => {
          if(_.has( item.children[0], 'class')){
            item.children[0].class += " bl"
          }else{
            item.children[0].class="bl"
          }
          return _.concat(result, item.children)
        }, [])
        return children
      }else {
        return this.columns || []
      }
    }
  },
  mounted() {
    if(this.hasPagination) {
      this.currentPageList = this.listData.slice(0, this.ps)
      //触发账户优化中分页记录日志
      this.$emit('pageChange', this.currentPageList)
    } else {
      this.currentPageList = this.listData
    }
    if(this.checkAll) {
      this.pushCheckList()
    }
  },
  methods: {
    onCheckAll() {
      if(this.checkAll) {
        this.pushCheckList()
      } else {
        this.cleanCheckList()
      }
    },
    pushCheckList() {
      let list = _.concat([], this.currentPageList).map(item => {
        this.$set(item, 'checked', true)
        return item
      })
      this.$store.dispatch("SET_TABLE_CHECKLIST", list)
    },
    cleanCheckList() {
      let checklist = _.concat([], this.$store.state.tableCheckList)
      checklist.map(item => {
        this.$set(item, 'checked', false)
        return item
      })
      this.$store.dispatch("SET_TABLE_CHECKLIST", [])
    },
    //建议table翻页事件
    updateAdvicePageData(pg) {
      this.pg = pg
      this.cleanCheckList()
      const start = (pg - 1) * this.ps
      const end = pg * this.ps
      this.checkAll =  false
      this.currentPageList = this.listData.slice(start, end)
      this.$emit('pageChange', this.currentPageList)
    },
    isAsc(value) {
      if (typeof value === 'number') {
          return value == 0 ? '' : value > 0 ? 'fa-long-arrow-up red':'fa-long-arrow-down green'
      } else {
          return '';
      }
    },
    // 单元格css
    tcellCustomClass(item,index) {
      return (_.has(item, 'class') ? _.has(item, 'sorter') ? index && index == this.columnChildren.length - 1 ? item.class + ' last-sort-pr' : item.class + ' sort_pr' : item.class  : '') + ' tdCell-' + item.key

    },
    // 是否是当前排序的key
    checkSorted(key, order) {
      return this.key == key && this.order == order
    },
    // 排序方法调用
    orderTable(item, order) {
      this.key = item.key
      this.order = order
      item.sorter(item.key, order)
    },
    checkboxChange(item) {
      let checklist = _.concat([], this.$store.state.tableCheckList)
      if(item.checked){
        checklist.push(item)
        //全选判断
        if(this.check_all && checklist.length == this.list.length){
          this.checkAll = true
        }
        if(checklist.length > parseInt(this.checkbox_length)){
          this.$set(checklist[0], 'checked', false)
          checklist.splice(0,1)
        }
      }else{
        this.checkAll = false
        checklist = _.filter(checklist, (item) => item.checked)
      }
      this.$store.dispatch("SET_DRAWCHART", true)
      this.$store.dispatch("SET_TABLE_CHECKLIST", checklist)
    }
  }
}

</script>
<style scoped>
@import '../css/base/variables.css';

.tdCell-landpage{ overflow: hidden;}
  .tdCell-bidword {
    overflow: hidden;
    text-overflow: ellipsis;
    min-width: 150px;
    white-space: nowrap;
  }
  .compTextIndent {
    margin-left: 20px;
  }
  .infoTextIndent {
    margin-left: 46px;
  }
  .textIndent {
    margin-left: 66px;
  }
  .select-all {
    position: relative;
    display: inline-block;
    border: 1px solid var(--Linegrey);
    line-height: 20px;
    padding: 3px;
    margin-right: 7px;
    margin-left: -7px;
  }
  .fa-caret-square-o-down {
    font-size: 19px;
    margin-left: 3px;
    color: var(--Grey);
    vertical-align: middle;
  }
  .dropdown-list {
    position: absolute;
    left: -14px;
    top: 26px;
    border: 1px solid var(--Linegrey);
    cursor: pointer;
    z-index: 99;
  }
  .dropdown-item {
    background: #fff;
    width: 80px;
    text-align: center;
  }
  .dropdown-list .active {
    font-weight: bold;
  }
</style>



// WEBPACK FOOTER //
// fold-table.vue?d907f5c8